<template>
  <div class="container-box">
    <MediaHeader />

    <div class="search-box-1 mb-n3 pb-5">
      <div></div>
      <div class="btn">
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click.prevent="modalCourse = true"
        >
          <v-icon left> mdi-plus </v-icon>
          코스 등록
        </v-btn>
      </div>
    </div>

    <p class="text-total-1 mb-3">
      총 <strong>{{ customBoardLists.length || 0 }}</strong
      >건 입니다.
    </p>
    <div class="table-wrap" style="position: relative">
      <v-data-table
        :headers="boardHeaders"
        :items="customBoardLists"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        class="board-list-1"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.create_at`]="{ item }">
          {{ item.create_at | moment('YYYY.MM.DD HH:mm:ss') }}
        </template>

        <template v-slot:[`item.is_valid`]="{ item }">
          <v-switch
            inset
            hide-details
            color="#fecd00"
            :input-value="item.is_valid === 'Y' ? true : false"
            :label="item.is_valid === 'Y' ? 'ON' : 'OFF'"
            class="switch-type-1 mt-0"
            @change="isValidPopup(item)"
          ></v-switch>
        </template>

        <template v-slot:[`item.modify`]="{ item }">
          <a
            href=""
            @click.prevent="modifyPopup(item)"
            style="color: transparent"
          >
            <v-icon color="#fecd00">mdi-cog-outline</v-icon>
          </a>
        </template>

        <template v-slot:no-data>
          <div class="text-center">
            등록된 코스가 없습니다. 우측상단 코스등록 버튼을 클릭후 코스를
            추가해주세요.
          </div>
        </template>
      </v-data-table>
    </div>
    <div class="pagination-1">
      <div class="sel-sort">
        <span>페이지당 행개수</span>
        <v-select
          :items="pageSel"
          :label="pageSel[0]"
          v-model="pageSelChoice"
          item-color="#000"
          class="input-custom-1"
          height="40px"
          solo
          @change="itemsPerPage = parseInt($event, 10)"
        ></v-select>
      </div>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == 1"
        @click="page = 1"
      >
        <v-icon>mdi-page-first</v-icon>
      </v-btn>

      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="10"
        color="transparent"
      ></v-pagination>

      <v-btn
        icon
        :plain="true"
        :ripple="false"
        :disabled="page == pageCount"
        @click="page = pageCount"
      >
        <v-icon>mdi-page-last</v-icon>
      </v-btn>
    </div>

    <!-- modalCourse -->
    <v-dialog
      persistent
      v-model="modalCourse"
      width="464"
      content-class="popup-wrap-1"
    >
      <div class="pa-9">
        <p class="title-type-4">코스 관리</p>
        <v-form ref="form">
          <div class="form-row-1">
            <p class="label">
              CC_ID
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                placeholder="20자 이내로 입력해주세요."
                class="input-custom-2"
                height="40px"
                v-model="modalCourseCCID"
                :rules="rules"
                solo
              ></v-text-field>
            </div>
          </div>

          <div class="form-row-1 mt-6">
            <p class="label">
              코스명
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-text-field
                placeholder="20자 이내로 입력해주세요."
                class="input-custom-2"
                height="40px"
                v-model="modalCourseName"
                :rules="courseNameRules"
                solo
              ></v-text-field>
            </div>
          </div>

          <div class="form-row-1 mt-6">
            <p class="label">노출 관리</p>
            <div class="write-con">
              <v-radio-group v-model="modalCourseRadio" class="mt-0" row>
                <v-radio
                  label="ON"
                  value="Y"
                  color="#fecd00"
                  class="radio-type-1"
                ></v-radio>
                <v-radio
                  label="OFF"
                  value="N"
                  color="#fecd00"
                  class="radio-type-1 ml-2"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </v-form>

        <div class="d-flex justify-end mt-6">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-2"
            @click.stop="modalCourseCancel"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1 ml-2"
            @click.prevent="registerOptions"
            :disabled="
              !modalCourseCCID || !modalCourseName || !modalCourseRadio
            "
          >
            저장
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <!-- //modalCourse -->

    <SystemAlert v-model="showSystemAlert" :persistent="true">
      <div slot="noti-text">{{ logResult }}</div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import {
  optionsList,
  optionsItemList,
  createOptionsItemList,
  updateOptionsItemList,
} from '@/api/options';

import SystemAlert from '~@/modal/SystemAlert';
import MediaHeader from '@/views/media/header';

export default {
  components: { MediaHeader, SystemAlert },
  data: () => ({
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardHeaders: [
      { text: 'No', value: 'no', width: '8%', sortable: false },
      { text: 'CC_ID', value: 'client_key', sortable: false },
      { text: '코스명', value: 'name', width: '20%', sortable: false },
      { text: '등록일', value: 'create_at', width: '14%', sortable: false },
      {
        text: '등록 관리자',
        value: 'creator.manager_name',
        width: '18%',
        sortable: false,
      },
      { text: '노출관리', value: 'is_valid', width: '18%', sortable: false },
      { text: '관리', value: 'modify', width: '8%', sortable: false },
    ],
    boardLists: [],
    modifyCourse: false,
    modifyCourseIsvalid: false,
    modifyCourseId: null,
    modalCourse: false,
    modalCourseCCID: '',
    modalCourseName: '',
    modalCourseRadio: 'Y',
    rules: [
      v => !!v || '필수 항목 입니다!',
      v => (v && v.length <= 20) || '최대 20자 이내로 입력해주세요.',
    ],
    courseNameRules: [
      v => !!v || '코스명을 입력해주세요.',
      v =>
        (v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글, 영문, 숫자만 입력 가능합니다.',
      v => (v && v.length <= 20) || '최대 20자 이내로 입력해주세요.',
    ],
    resultType: '',
    logResult: '',
    showSystemAlert: false,
    courseId: null,
  }),
  computed: {
    customBoardLists() {
      this.boardLists.forEach((item, index) => {
        item.no = this.boardLists.length - index;
        item.modify = '수정';
      });
      return this.boardLists;
    },
  },
  methods: {
    async getOptions() {
      try {
        const { data } = await optionsList();
        const lists = data.list;
        lists.forEach(option => {
          if (option.name === 'CC 코스' && !option.key) {
            this.courseId = option.id;
          }
        });
      } catch (error) {
        console.log(error.response);
      }
    },
    async getListOptionCourse() {
      try {
        const id = this.courseId;
        const { data } = await optionsItemList(id);
        const getListOptionCourse = data.list;
        this.boardLists = getListOptionCourse.reverse();
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
      }
    },
    async registerOptions() {
      bus.$emit('start:spinner');
      try {
        const courseData = {
          client_key: this.modalCourseCCID.trim(),
          name: this.modalCourseName.trim(),
          is_valid: this.modalCourseRadio,
        };
        const id = this.courseId;
        const { data } = this.modifyCourse
          ? await updateOptionsItemList(id, this.modifyCourseId, courseData)
          : await createOptionsItemList(id, courseData);

        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = `코스가 ${
            this.modifyCourse ? '수정' : '등록'
          } 되었습니다.`;
          this.$refs.form.reset();
          this.modifyCourse = false;
        }
      } catch (error) {
        bus.$emit('end:spinner');
        const { data } = error.response;
        this.resultType = data.result;
        this.$refs.form.reset();
        this.modifyCourse = false;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 매체명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      }
    },
    closePopup() {
      const type = this.resultType;
      this.showSystemAlert = false;
      if (type === 'success') {
        bus.$emit('start:spinner');
        this.modalCourse = false;
        this.getListOptionCourse();
      }
    },
    modifyPopup(item) {
      this.modalCourse = true;
      this.modifyCourse = true;

      this.modifyCourseId = item.id;
      this.modalCourseRadio = item.is_valid;
      this.modalCourseCCID = item.client_key;
      this.modalCourseName = item.name;
    },
    async isValidPopup(item) {
      this.modifyCourse = true;
      this.modifyCourseIsvalid = true;
      bus.$emit('start:spinner');
      try {
        const courseData = {
          client_key: item.client_key.trim(),
          name: item.name.trim(),
          is_valid: item.is_valid === 'Y' ? 'N' : 'Y',
        };
        const { data } = await updateOptionsItemList(
          this.courseId,
          item.id,
          courseData,
        );
        if (data.result === 'success') {
          bus.$emit('end:spinner');
          this.resultType = data.result;
          this.showSystemAlert = true;
          this.logResult = '노출 설정을 변경하였습니다.';
          this.modifyCourse = false;
          this.modifyCourseIsvalid = false;
        }
      } catch (error) {
        bus.$emit('end:spinner');
        const { data } = error.response;
        this.resultType = data.result;
        this.modifyCourse = false;
        this.modifyCourseIsvalid = false;
        if (data.result === 'DuplicatedEntry') {
          this.showSystemAlert = true;
          this.logResult = '이미 사용중인 매체명이 있습니다.';
        } else if (data.result === 'ParameterValidation') {
          this.showSystemAlert = true;
          this.logResult = '등록에 실패하였습니다. 재등록 부탁드립니다.';
        }
      }
    },
    modalCourseCancel() {
      this.$refs.form.reset();
      this.modifyCourseId = null;
      this.modifyCourse = false;
      this.modifyCourseIsvalid = false;
      this.modalCourse = false;
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getOptions();
    await this.getListOptionCourse();
  },
};
</script>
